import { motion, useReducedMotion } from "framer-motion";
import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";

const STEPS = [
  { word: "FEEL", note: "Anger. Fear. Grief. Whatever is there." },
  { word: "PAUSE", note: "Create a gap before the feeling becomes an action." },
  { word: "UNDERSTAND", note: "What’s actually happening? What do you actually want?" },
  { word: "RESPOND", note: "Act deliberately, not on adrenaline." },
];

export const Method = () => {
  const reduce = useReducedMotion();
  return (
    <section id="method" className="bg-night text-paper" data-testid="method-section">
      <div className="mx-auto max-w-6xl px-5 md:px-8 py-24 md:py-36">
        <Chapter
          n={2}
          kicker="The method"
          title={
            <>
              There <span className="text-pine">IS</span> a space between
              feeling something and doing something.
            </>
          }
          dark
        />
        <Reveal>
          <p
            className="font-serif text-3xl md:text-5xl tracking-tight text-paper/45 line-through decoration-paper/50 decoration-2"
            data-testid="method-old-pattern"
          >
            FEEL → REACT
          </p>
        </Reveal>
        <motion.p
          initial={reduce ? false : { opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 font-serif text-3xl md:text-5xl tracking-tight leading-tight text-paper"
          data-testid="method-new-pattern"
        >
          FEEL <span className="text-pine" aria-hidden="true">→</span> PAUSE{" "}
          <span className="text-pine" aria-hidden="true">→</span> UNDERSTAND{" "}
          <span className="text-pine" aria-hidden="true">→</span> RESPOND
        </motion.p>
        <Reveal delay={0.25}>
          <p
            className="mt-6 font-serif text-xl md:text-2xl text-paper/70"
            data-testid="method-space-line"
          >
            That’s the space we’re trying to create.
          </p>
        </Reveal>
        <div className="mt-16 grid gap-10 md:grid-cols-4 md:gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.word}
              initial={reduce ? false : { opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="border-t border-paper/15 pt-6"
              data-testid={`method-step-${s.word.toLowerCase()}`}
            >
              <p className="font-serif text-xl md:text-2xl tracking-tight text-paper">
                {s.word}
              </p>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-paper/60">
                {s.note}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
